/**
 * @generated SignedSource<<46cd3adca90cdc543987b103a74d7570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDeleteStorecastMutation$variables = {
  storecastId: string;
};
export type useDeleteStorecastMutation$data = {
  readonly deleteDashboard: {
    readonly id: string;
  } | null;
};
export type useDeleteStorecastMutation = {
  response: useDeleteStorecastMutation$data;
  variables: useDeleteStorecastMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteStorecastMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "deleteDashboard",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteStorecastMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "deleteDashboard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3aa7cbec902f1822f135333d28acfb46",
    "id": null,
    "metadata": {},
    "name": "useDeleteStorecastMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteStorecastMutation(\n  $storecastId: ID!\n) {\n  deleteDashboard(id: $storecastId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7790ccede2dec3f2b35c41bc5a78521a";

export default node;
